module.exports = __webpack_public_path__ + "img/games-5.52360912.jpg";